import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "upload-button-wrapper" }
const _hoisted_2 = ["disabled", "onClick", "aria-label", "onKeydown"]
const _hoisted_3 = ["src"]

import UploadIcon from "../assets/images/UploadIcon.svg";
import UploadWhite from "../assets/images/Upload-white.svg";

import type { FileUploadUploaderEvent } from 'primevue/fileupload';

import { computed } from 'vue';
import { useSupplementaryUpload } from '../composables/useSupplementaryUpload';


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadButton',
  props: {
    type: {},
    additionalUploads: {},
    sessionId: {},
    onInfoPanel: { type: Boolean },
    onSessionClick: { type: Function }
  },
  setup(__props: any) {

const { isUploading, handleSupplementaryUpload } = useSupplementaryUpload();

const props = __props

const isSupplementaryLimitReached = computed(() => {
    return (
        props.type === 'supplementaryFiles' &&
        (props.additionalUploads?.filter((upload) => upload.type === 'mp-supplementary')?.length || 0) > 4
    );
});

const isDisabled = computed(() => {
    return isSupplementaryLimitReached.value || isUploading.value;
});

const buttonConfig = computed(() => {
    switch (props.type) {
        case 'supplementaryFiles':
        return {
            text: 'Upload',
            buttonClass: props.onInfoPanel ? 'supplementary-upload-button-info-panel' : 'supplementary-upload-button',
            textClass: props.onInfoPanel ? '' : 'supplementary-button-text',
            imageClass: props.onInfoPanel ? '' : 'supplementary-button-image',
            acceptedExtension: ".pdf",
        }
        case 'session':
        return {
            text: 'Upload file',
            buttonClass: 'session-upload-button',
            textClass: 'session-button-text',
            imageClass: 'session-button-image',
            acceptedExtension: ".m4a,.aac,.caf,.wav,.mp3,.mp4,.webm,.avi",
        }
        default:
        return {
            text: 'Default',
            buttonClass: '',
            textClass: '',
            imageClass: '',
            acceptedExtension: ".m4a,.aac,.caf,.wav,.mp3,.pdf,.mp4,.webm,.avi"
        }
    }
});

const handleClick = async (event: FileUploadUploaderEvent) => {
    if (props.type === 'session'){
        props.onSessionClick?.();
        return;
    }
    await handleSupplementaryUpload(event, props.sessionId);
}


return (_ctx: any,_cache: any) => {
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FileUpload, {
      ref: "fileUploader",
      mode: "advanced",
      name: "file",
      auto: false,
      accept: buttonConfig.value.acceptedExtension,
      disabled: isDisabled.value,
      customUpload: true,
      chooseLabel: buttonConfig.value.text,
      chooseIcon: '',
      onSelect: handleClick,
      "aria-labelledby": "Upload supplementary files",
      "aria-describedby": `Session has ${props.additionalUploads?.filter((upload) => upload.type === 'mp-supplementary')?.length || 0} supplementary files attached`
    }, {
      header: _withCtx(({ chooseCallback }) => [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(buttonConfig.value.buttonClass),
          disabled: isDisabled.value,
          onClick: ($event: any) => (chooseCallback()),
          "aria-label": buttonConfig.value.text,
          onKeydown: ($event) => {
                        if ($event.key === 'Enter') {
                            $event.preventDefault();
                            chooseCallback();
                        }
                    }
        }, [
          _createElementVNode("img", {
            src: props.onInfoPanel ? _unref(UploadWhite) : _unref(UploadIcon),
            alt: 'Upload icon',
            role: "presentation",
            class: _normalizeClass(buttonConfig.value.imageClass)
          }, null, 10, _hoisted_3),
          _createElementVNode("span", {
            class: _normalizeClass(buttonConfig.value.textClass)
          }, _toDisplayString(buttonConfig.value.text), 3)
        ], 42, _hoisted_2)
      ]),
      _: 1
    }, 8, ["accept", "disabled", "chooseLabel", "aria-describedby"])
  ]))
}
}

})